(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtri-lab"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-flab]').forEach((root) => {
    if (root.dataset.flabInit) return;
    root.dataset.flabInit = 'true';

    const items = Array.from(root.querySelectorAll('[data-item]'));
    const pills = Array.from(root.querySelectorAll('[data-feel-pill]'));
    const firmnessMin = root.querySelector('[data-firmness-min]');
    const firmnessMax = root.querySelector('[data-firmness-max]');
    const coolingMin = root.querySelector('[data-cooling-min]');
    const priceMax = root.querySelector('[data-price-max]');
    const countEl = root.querySelector('[data-count]');
    const countWordEl = root.querySelector('[data-count-word]');
    const emptyEl = root.querySelector('[data-empty]');
    const resetButtons = Array.from(root.querySelectorAll('[data-reset]'));

    const state = { feel: '' };

    const num = (value) => {
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const isDefault = () => {
      if (state.feel) return false;
      if (firmnessMin && (num(firmnessMin.value) > num(firmnessMin.min) || num(firmnessMax.value) < num(firmnessMax.max))) return false;
      if (coolingMin && num(coolingMin.value) > num(coolingMin.min)) return false;
      if (priceMax && num(priceMax.value) < num(priceMax.max)) return false;
      return true;
    };

    const syncRangeVisuals = () => {
      if (firmnessMin && firmnessMax) {
        // I due cursori non possono incrociarsi
        if (num(firmnessMin.value) > num(firmnessMax.value)) {
          firmnessMin.value = firmnessMax.value;
        }
        const wrap = firmnessMin.closest('.flab__range');
        wrap.style.setProperty('--lo', `${firmnessMin.value}%`);
        wrap.style.setProperty('--hi', `${firmnessMax.value}%`);
        const output = root.querySelector('[data-firmness-value]');
        if (output) {
          const lo = num(firmnessMin.value);
          const hi = num(firmnessMax.value);
          output.textContent = lo === 0 && hi === 100 ? 'Tutte' : `${lo}–${hi}`;
        }
      }
      if (coolingMin) {
        const wrap = coolingMin.closest('.flab__range');
        wrap.style.setProperty('--hi', `${coolingMin.value}%`);
        const output = root.querySelector('[data-cooling-value]');
        if (output) {
          output.textContent = num(coolingMin.value) === 0 ? 'Qualsiasi' : `≥ ${coolingMin.value}`;
        }
      }
      if (priceMax) {
        const wrap = priceMax.closest('.flab__range');
        const min = num(priceMax.min);
        const max = num(priceMax.max);
        const percent = max > min ? ((num(priceMax.value) - min) / (max - min)) * 100 : 100;
        wrap.style.setProperty('--hi', `${percent}%`);
        const output = root.querySelector('[data-price-value]');
        if (output) output.textContent = `${priceMax.value} €`;
      }
    };

    const matches = (item) => {
      const data = item.dataset;
      if (state.feel && data.feel !== state.feel) return false;

      const firmness = num(data.firmness);
      if (firmnessMin && firmness !== null) {
        if (firmness < num(firmnessMin.value) || firmness > num(firmnessMax.value)) return false;
      }

      const cooling = num(data.cooling);
      if (coolingMin && cooling !== null && cooling < num(coolingMin.value)) return false;

      const price = num(data.price);
      if (priceMax && price !== null && price > num(priceMax.value)) return false;

      return true;
    };

    const apply = () => {
      syncRangeVisuals();

      let visible = 0;
      items.forEach((item) => {
        const show = matches(item);
        if (show) {
          if (item.hidden) {
            item.hidden = false;
            // riparte la piccola animazione di ingresso
            item.style.animation = 'none';
            void item.offsetWidth;
            item.style.animation = '';
          }
          visible += 1;
        } else {
          item.hidden = true;
        }
      });

      if (countEl) countEl.textContent = visible;
      if (countWordEl) countWordEl.textContent = visible === 1 ? 'materasso' : 'materassi';
      if (emptyEl) emptyEl.hidden = visible > 0;

      const defaults = isDefault();
      resetButtons.forEach((button) => {
        if (button.closest('.flab__meta')) button.hidden = defaults;
      });
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        state.feel = pill.dataset.feelPill;
        pills.forEach((p) => {
          const active = p === pill;
          p.classList.toggle('flab__pill--active', active);
          p.setAttribute('aria-pressed', String(active));
        });
        apply();
      });
    });

    [firmnessMin, firmnessMax, coolingMin, priceMax].forEach((input) => {
      if (input) input.addEventListener('input', apply);
    });

    resetButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.feel = '';
        pills.forEach((p) => {
          const active = p.dataset.feelPill === '';
          p.classList.toggle('flab__pill--active', active);
          p.setAttribute('aria-pressed', String(active));
        });
        if (firmnessMin) firmnessMin.value = firmnessMin.min;
        if (firmnessMax) firmnessMax.value = firmnessMax.max;
        if (coolingMin) coolingMin.value = coolingMin.min;
        if (priceMax) priceMax.value = priceMax.max;
        apply();
      });
    });

    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
